const styles = () => ({
  integrationCopy: {
    color: 'rgb(90, 97, 104);',
    fontSize: 14,
    marginBottom: 25,

    '& p': {
      margin: 0,
    },

    '& p:first-of-type': {
      marginBottom: 10,
    },
  },

  integrationLink: {
    textDecoration: 'underline',
    color: '#148CFC',
  },

  snippetContainer: {
    borderRadius: '6px 6px 6px 6px',
    border: '1px solid rgb(225, 233, 240)',
    backgroundColor: '#FAFBFC',
  },

  snippet: {
    padding: '8px 29px 4px 14px',
    borderRadius: '6px 6px 0px 0px',
    background: 'transparent',
    overflow: 'auto',
    fontSize: 12,
    fontFamily: 'Monaco, consolas, monospace',
    fontWeight: 'normal',
    lineHeight: '20px',
    color: 'rgb(39, 40, 42)',
    width: '100%',
    border: 'none',
    resize: 'none',
    cursor: 'default',

    '&:focus': {
      outline: 'none',
    },
  },

  copyContainer: {
    display: 'flex',
    backgroundColor: 'white',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 56,
    borderTop: '1px solid rgb(225, 233, 240)',
    padding: '0 17px',
    borderRadius: '0 0 6px 6px',
  },

  copyText: {
    color: '#148cfc',
    fontSize: 14,
    fontWeight: 500,
    marginLeft: 9,
  },

  iconTextContainer: {
    display: 'flex',
  },
});

export default styles;
